import { render, staticRenderFns } from "./DualListBox.vue?vue&type=template&id=3042d5aa"
import script from "./DualListBox.vue?vue&type=script&lang=ts"
export * from "./DualListBox.vue?vue&type=script&lang=ts"
import style0 from "./DualListBox.vue?vue&type=style&index=0&id=3042d5aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports